import { Injectable } from '@angular/core';
import { UserClaims, Claims } from '@mitel/cloudlink-sdk';
import { Subject } from 'rxjs';
import { Account } from '@mitel/cloudlink-sdk';


@Injectable({
  providedIn: 'root'
})
export class AppUserClaimsService {
	private claims: UserClaims;
  private claimsCloud: String = undefined;
  public claimsChanged = new Subject<UserClaims>();
  public claimsHandledFlag: Boolean = false;
  public claimsHandled = new Subject<Boolean>(); //used for refresh
  private loggedInUser = undefined; // because claims does not have all the information required

  constructor() { }

  getClaims() {
  	return this.claims;
  }

  setClaims(claims: UserClaims) {
  	this.claims = claims;
  	this.claimsChanged.next(this.claims);
  }

  isAssumedRole(): boolean
  {
    if (localStorage.getItem('@mitel/token.original_token'))
      return true;

    return false;
  }

  getClaimsHandledFlag(){
    return this.claimsHandledFlag;
  }

  setClaimsHandled(flag: Boolean) {
    this.claimsHandledFlag = flag;
    this.claimsHandled.next(flag);
  }

  getClaimsCloud(){
    return this.claimsCloud;
  }

  setClaimsCloud(cloud: string){
    this.claimsCloud = cloud;
  }

  setCloudFromClaims(){
    let claims: any = this.claims; //.iss does not exist on UserClaims interface
    let cloud = undefined;

    if (claims && claims.iss) {
      const iss = claims.iss; //e.g. https://authentication.us-east-1.us.dev.api.mitel.io/cloudlink
      const issSplit = iss.split('.');
      cloud = issSplit.length>1? issSplit[1] : undefined; //e.g. us-east-1
    }
    this.claimsCloud = cloud;
    console.log("ClaimsCloud: ", this.claimsCloud);
  }

  hasTheClaimsChanged( account: Account, newClaims: Claims ): boolean
  {
    if ( this.claimsHandledFlag == false )
      return false;

    if ( this.claims && this.claims.role == "ACCOUNT_ADMIN" )
    {
      if ( newClaims.role != "ACCOUNT_ADMIN" || newClaims.principalId != this.claims.principalId )
        return true;
    }
    else if ( this.claims && this.claims.role == "USER" )
    {
      if ( newClaims.role != "USER" || newClaims.principalId != this.claims.principalId )
        return true;
    }
    else
    {
      if ( newClaims.role == "PARTNER_ADMIN" && newClaims.principalId != this.claims.principalId )
      {
        return true;
      }
      if ( this.isAssumedRole() &&  
          (newClaims.role != "ACCOUNT_ADMIN" || newClaims.accountId != account.accountId) )
      {
        return true;
      }
      if ( newClaims.role == "ACCOUNT_ADMIN" && 
          ( this.isAssumedRole() == false || 
          ( this.isAssumedRole() == true && newClaims.accountId != account.accountId )) )
        return true;
    }
    return false;
  }

  setLoggedInUser( user )
  {
    this.loggedInUser = user;
  }

  getLoggedInUser()
  {
    return this.loggedInUser;
  }

  getUserSource()
  {
    if ( this.loggedInUser )
      return this.loggedInUser.source;
    return undefined;
  }
}
